import { selector } from "@store/Framework/Common/Hooks/useWebsite/selector";
import { useSelector } from "react-redux";

export const useWebsite = () => {
    return useSelector(selector);
};
